import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import SMSMessage from './../components/SMSMessage';
import { sendMessage } from '../actions/smsActions';
import { getUmpiresList, updateUmp } from '../actions/umpireActions';

const mapStateToProps = state => ({
  // Include the necessary state props
  umpires: state.umpires.umpires,
  umpiresSeason: state.lists.umpiresSeason,
  umpiresSeasonList: state.lists.umpiresSeasonList,
  fetchingUmpiresList: state.lists.fetchingUmpiresList,
  userSeason: state.user.userSeason,
  filters: state.filters // Assuming filters are stored in the Redux store
});

const mapDispatchToProps = dispatch => {
  return {
    sendMessage: (message, recipients) => {
      dispatch(sendMessage(message, recipients));
    },
    getUmpiresList: seasonId => {
      dispatch(getUmpiresList(seasonId));
    },
    updateUmp: (seasonId, memberId, umpLevel) => {
      dispatch(updateUmp(seasonId, memberId, umpLevel));
    }
  };
};

const SMSMessageContainer = withRouter(connect(mapStateToProps, mapDispatchToProps)(SMSMessage));

export default SMSMessageContainer;



// WEBPACK FOOTER //
// ./src/containers/SMSMessageContainer.js